import type { FeedFilter } from 'types/interfaces/feed';

export const POLLING_INTERVAL_MS = 60_000;
export const FEED_WINDOW = '14d';
export const FEED_PAGE_SIZE = 20;
export const SCROLL_BUFFER_THRESHOLD_PX = 200;
export const CARD_SEARCH_DEBOUNCE_MS = 250;

export const FILTER_OPTIONS: { value: FeedFilter; label: string }[] = [
  { value: 'all', label: 'All' },
  { value: 'sent', label: 'Sent' },
  { value: 'received', label: 'Received' },
  { value: 'new_wants', label: 'New Wants' },
];

export type FeedViewMode = 'packages' | 'list';

export const VIEW_MODE_STORAGE_KEY = 'feed-view-mode';

export const VIEW_OPTIONS: { value: FeedViewMode; label: string }[] = [
  { value: 'packages', label: 'Packages' },
  { value: 'list', label: 'List' },
];
